// src/ColorConstants.js
// Central mapping of named colors, plus an array of values for random selection

export const COLOR_CONSTANTS = {
    DEEP_GREEN: '#113025',
    SWAMP_BLUE: '#153D4B',
    EMERALD: '#389460',
    LEMON_LIME: '#B2DC43',
    GHOST_WHITE: '#F9F8EA',

    YELLOW: '#F0C637',
    HONEY: '#F1B53B',
    HOT_ORANGE: '#D66011',
    MELON_DEW: '#86AE58',

    SMOKE: '#3A383F',
    ELEPHANT: '#7E7A86',
    STRAWBERRY_ICING: '#CEABB4',
    PINK_CREAM: '#F6ECF0',
    BOLD_RED: '#C44136',

    STONE_BROWN: '#735C52',
    TOTAL_BLACK: '#151412',
    SCREEN_BLACK: '#292B3B',
    TV_PURPLE: '#824F90',
    LAVENDER: '#8481B2',

    SEA_BLUE: '#1D3840',
    FROG_GREEN: '#408345',
    YELLOW_SAND: '#CDD076',
    BRIGHT_LEMON: '#CFEE5F',
    RED_CAPE: '#C2302C',

    ELECTRIC_VIOLET: '#6C60B3',
    MIDNIGHT_BLUE: '#1E2764',
    SHADOW_PURPLE: '#1A1825',
    GREY_CYAN: '#608B9E',
    YELLOW_CLAY: '#B6C56C',

    DEEP_PURPLE: '#21142C',
    INDIGO: '#291C56',
    CANADA_FIRE: '#CA2D23',

    SALMON: '#CF7176',
    ULTRA_PURPLE: '#481B77',
    NEON_RED: '#EF0E40',
    WATER_MELON: '#C34465',

    GREEN_STUCCO: '#08A688',
    DARK_GREEN: '#112A25',
    BLUE_PLANET: '#1A409B',

    BRIGHT_MAROON: '#C61348',
    BLUE_NOISE: '#0D688C',
    CYAN: '#0CC6D8',
    SUNFLOWER: '#FBD412',
    ORANGE_FIRE: '#E65E3C',

    THC: '#5A8F57',
    EAST_BLUE: '#2139C9',
    NAVY_BLUE: '#0A2945',
    RED: '#DB230E',
    EVERGREEN: '#36562A',

    POLMOLO: '#BFD988',
    PURPLE_ROSE: '#6E3E63',
    BLUE_BULLET: '#285286',
    SKY_BLUE: '#66B2D8',

    CLOUDY_WHITE: '#D6D8DD',
    CREAM: '#C8C2D7',

    BLACK_SCREEN2: '#383637',
    SHADOW: '#414049',
    CLEAR_BLUE: '#308FA6',
    COLD_WHITE: '#FFFEFC',
    COLD_GREY: '#D6D6D6',

    ELECTRIC_VIOLET2: '#6C5295',
    TOTAL_BLACK2: '#201E26',

    MAJESTIC_GREEN: '#29573C',
    FOREST: '#315942',
    MUSTARD: '#B0A23D',
    PEACH: '#FAA25F',

    BRIGHT_ROSE: '#A21D6A',
    SKY_BLUE2: '#3F84B8',
    OCEAN_DARK: '#0D1D29',
    INDIGLOW: '#504EC1',

    SHADOW2: '#35373F',
    PUMPKIN: '#EF6C2D',
    LIGHT_WOOD: '#E9DDB0',
    DARK_PURPLE: '#3A1D49',

    CRIMSON: '#79180F',
    DARK_PURPLE2: '#382533',
    LEMON: '#DBE64B',

    BLACK_HOLE: '#252225',

    GREEN_SCREEN: '#1DD772',
    BLUE: '#225695',
    FERN: '#24714C',
    DARKEST_BLUE: '#110E21',
    LIME: '#62B944',
    RED_VELVET: '#761E26',
    WHITE_STONE: '#F0F4EC',
    BROWN_TREE: '#2B221C',

    // Continue adding all other named colors...
};

export const COLORS = Object.values(COLOR_CONSTANTS);
export default COLORS;
